import React, {useContext, useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import Title from "./Title";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import {db} from "../services/firebase";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import {SubmissionsContext} from "../providers/SubmissionsProvider";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import {Link} from "@material-ui/core";
import DoneIcon from '@material-ui/icons/Done';
import Divider from "@material-ui/core/Divider";
import {GlobalContext} from "../providers/GlobalProvider";
import firebase from "firebase";
import {LeaderboardContext} from "../providers/LeaderboardProvider";
const fieldValue = firebase.firestore.FieldValue;

// Generate Order Data
function createData(id, user, link, topic, problems) {
    return { id, user, link, topic, problems };
}

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        display: "flex",
        overflow: "auto",
        flexDirection: "column",
    },
    loader: {
        margin: theme.spacing(1),
    },
    root: {
        padding: theme.spacing(2),
        display: "flex",
        marginTop: theme.spacing(1),
        overflow: "auto",
        flexDirection: "column",
        backgroundColor: "#fefefefe",
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
    },
    iconButton: {
        padding: 10,
    },
}));

export default function Submissions() {
    const submissions = useContext(SubmissionsContext).submissions;

    let rows = [];
    for (let k in submissions) {
        let userSubmissions = submissions[k];
        for(let subid in userSubmissions) {
            let sub = userSubmissions[subid];
            rows.push(
                createData(subid, k, sub.link, sub.topic, sub.problems)
            );
        }
    }

    return (
        <React.Fragment>
            <Title>Submissions</Title>
            <FormGroup row>
                {rows.map((row, index) => (
                    <Submission
                        key={index}
                        id={row.id}
                        user={row.user}
                        link={row.link}
                        topic={row.topic}
                        problems={row.problems}
                    />
                ))
                }

            </FormGroup>
        </React.Fragment>
    );
}

function Submission({id, user, link, topic, problems}) {
    let initialChecked = {};
    const classes = useStyles();
    const globalState = useContext(GlobalContext);
    const leaderboardState = useContext(LeaderboardContext);
    let userProblemsSolved = {};
    problems.forEach((problem)=>{userProblemsSolved[problem] = true;})
    if (user in leaderboardState.users && topic in leaderboardState.users[user].solvedProblems) {
        userProblemsSolved = leaderboardState.users[user].solvedProblems[topic];
    }
    problems.forEach((name) => {
        initialChecked[name] = false;
    })
    const [checked, setChecked] = useState(initialChecked);
    const handleCheck = (event) => {
        setChecked({...checked, [event.target.name]: event.target.checked })
    }
    const handleSubmit = (event) => {
        event.preventDefault();
        let ps = [];
        for (let k in checked) {
            if (checked[k]) {
                ps.push(k);
            }
        }
        if (window.confirm("Are you sure you would like to mark the following problems correct: " + ps.join(", ")+ "?")) {
            gradeProblems(ps);
        }
        let newChecked = {};
        problems.forEach((name) => {
            newChecked[name] = false;
        })
        setChecked(newChecked);
    };

    const gradeProblems = (ps) => {
        db.collection("fileSubmissions").doc(user).set({
            [id]: fieldValue.delete()
        }, {merge:true});
        if (ps.length === 0) {
            return;
        }
        let updateMap = {};
        let scoreIncrease = 0;
        ps.forEach((problem) => {
            updateMap[problem] = firebase.firestore.Timestamp.now();
            scoreIncrease += globalState.topics[topic].problems[problem].points;
        })

        db.collection("leaderboard").doc(user).set({
            score: fieldValue.increment(scoreIncrease),
            solvedProblems: {[topic]: updateMap}
        }, {merge: true});
    }
    return (
        <Grid item xs={12}>
            <Paper className={classes.root} style={{ textAlign: "left" }}>
                <Typography variant="body1">
                    User ID: {user}, Topic ID: {topic}
                </Typography>
                <Typography variant="body1">
                    Link: <Link component="a" href={link}>{link}</Link>
                </Typography>
                <Divider style={{margin: "10px 0px"}}/>
                <Typography variant="body1">
                    Select which problems were answered correctly, then hit the check to finish grading.
                </Typography>
                <FormGroup row>
                    {problems.map((name, index) => (
                        <FormControlLabel
                            key={index}
                            control={
                                <Checkbox
                                    disabled={name in userProblemsSolved}
                                    color={"primary"}
                                    checked={!(name in userProblemsSolved) && checked[name]}
                                    onChange={handleCheck}
                                    name={name}
                                />
                            }
                            label={name}
                        />
                    ))
                    }
                    <IconButton
                        onClick={handleSubmit}
                    >
                        <DoneIcon/>
                    </IconButton>

                </FormGroup>
            </Paper>
        </Grid>
    );
}
